export default __webpack_public_path__ + "static/media/errorTll.c9da272d.svg";